import {
	IsBoolean,
	IsEnum,
	IsInt,
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsString,
	IsUUID,
} from 'class-validator';
import { TradePosition } from '../../enums';

export class GetTradesParamsDto {
	@IsUUID()
	user_id: string;

	@IsOptional()
	@IsUUID()
	event_id?: string;

	@IsOptional()
	@IsUUID()
	lobby_id?: string;

	@IsOptional()
	@IsUUID()
	match_id?: string;
}

export class MakeSecondChanceTradeDto {
	@IsUUID('4')
	@IsNotEmpty()
	lobby_id: string;

	@IsUUID('4')
	@IsNotEmpty()
	second_chance_market_id: string;

	@IsNumber()
	value: number;
}

export class MakeTradeDto {
	@IsUUID('4')
	@IsNotEmpty()
	marketId: string;

	@IsUUID('4')
	@IsNotEmpty()
	lobbyId: string;

	@IsOptional()
	@IsEnum(TradePosition)
	position?: TradePosition;

	@IsOptional()
	@IsBoolean()
	isSilentUpdate?: boolean;

	@IsOptional()
	@IsBoolean()
	isFirstMatchTrade?: boolean;

	@IsOptional()
	@IsString()
	lobbyType?: string;
}

export class TradesEventFilterDto {
	@IsUUID('4')
	@IsNotEmpty()
	eventId: string;

	@IsOptional()
	@IsUUID('4')
	lobbyId?: string;
}

export class GetTradesListDto extends TradesEventFilterDto {
	@IsOptional()
	@IsInt()
	pageSize?: number | null;

	@IsOptional()
	@IsInt()
	page?: number | null;
}

export class CanMakeAutoTradesDto {
	@IsUUID('4')
	@IsNotEmpty()
	lobbyId: string;

	@IsUUID('4')
	@IsNotEmpty()
	marketId: string;

	@IsOptional()
	@IsBoolean()
	isAutoLock?: boolean;
}
